export default __webpack_public_path__ + "4b8d0b43585d7eca448af36d5bd8886d.png";